import { CompanyRegistrationPlace } from '../components/CompanyRegistration';
import { useCompanyRegistrationPlace } from '../hooks';
import { PageComponentProps } from '../types';

export const CompanyRegistrationPlaceStep = ({
  canGoBack,
}: PageComponentProps) => {
  const {
    countries,
    countriesLoading,
    initialValues,
    submitLoading,
    onSubmit,
    goToBack,
  } = useCompanyRegistrationPlace();

  return (
    <CompanyRegistrationPlace
      canGoBack={canGoBack}
      countries={countries}
      countriesLoading={countriesLoading}
      initialValues={initialValues}
      submitLoading={submitLoading}
      onGoBack={goToBack}
      onSubmit={onSubmit}
    />
  );
};
